interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  circle?: boolean;
  className?: string;
}

export default function Skeleton({ width, height, circle = false, className = '' }: SkeletonProps) {
  const style: React.CSSProperties = {
    width: width ? (typeof width === 'number' ? `${width}px` : width) : '100%',
    height: height ? (typeof height === 'number' ? `${height}px` : height) : '20px'
  };

  return (
    <div
      className={`animate-pulse bg-muted/30 rounded ${circle ? 'rounded-full' : ''} ${className}`}
      style={style}
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="bg-card rounded-2xl p-4 border border-border animate-pulse">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-muted/30" />
        <div className="flex-1">
          <div className="h-4 w-24 bg-muted/30 rounded mb-2" />
          <div className="h-3 w-16 bg-muted/30 rounded" />
        </div>
      </div>
      <div className="h-12 w-full bg-muted/30 rounded" />
    </div>
  );
}

export function SkeletonList({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
